import { Box, IconButton, Modal } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import cssClasses from "./CancellationBankDetails.module.css";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../../Subcomponents/Button";
import {
  UpdateLedgerData,
  getCustomerLedgerId,
  getPanAndBankBookingDetails,
  getPanAndBankConfirmationDetails,
  inserRefundFormLedger,
  updateBankRecordStatus,
} from "../../Services/Bank";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { errorTost, successTost } from "../../Services/Toast";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../../Components/Icons/Dot";
import ViewAcceptDetailsModal from "./ViewAcceptDetailsModal";

const ViewBankDetailsModal = ({ open, handleClose, selectedBankDetails }) => {
  const [panNumberDetails, setPanNumberDetails] = useState();
  const [showAcceptConfirmationModal, setShowAcceptConfirmationModal] =
    useState(false);
  const [bookAppData, setBookAppData] = useState([]);
  const [panBankData, setPanBankData] = useState([]);
  const isAccepted = useRef(false);
  const [isAlreadyAccepted, setIsAlreadyAccepted] = useState(false);

  useEffect(() => {
    if (selectedBankDetails) {
      getPanNumberDetails();
    }
  }, []);

  const getPanNumberDetails = () => {
    presentLoader();
    getPanAndBankBookingDetails(selectedBankDetails?.panNumber)
      .then((resp) => {
        if (resp?.data?.status) {
          setPanNumberDetails({
            description:
              resp?.data?.data[0]?.customer?.FirstName +
              " " +
              resp?.data?.data[0]?.customer?.MiddleName +
              (resp?.data?.data[0]?.customer?.MiddleName ? " " : "") +
              resp?.data?.data[0]?.customer?.LastName,
            email: resp?.data?.data[0]?.customer?.Email,
            mobile: resp?.data?.data[0]?.customer?.MObile,
            UDF_16: resp?.data?.data[0]?.customer?.UDF_16,
          });
          setBookAppData(resp?.data?.data[0]?.booking);
          setPanBankData(resp?.data?.data);
        }

        dismissLoader();
      })
      .catch((e) => {
        dismissLoader();
        errorTost(e.message);
      });
  };
  const handleUpdateStatus = (status, value, count = 0) => {
    presentLoader();
    updateBankRecordStatus(status, value?.panNumber)
      .then((val) => {
        handleClose(true);
        dismissLoader();
        if (status === "accepted" && count !== 0) {
          successTost(
            `${selectedBankDetails?.customerBankDetails?.accHolderName} request has been accepted successfully`
          );
        } else if (status === "rejected") {
          successTost(
            `${selectedBankDetails?.customerBankDetails?.accHolderName} request has been rejected successfully`
          );
        }
      })
      .catch((err) => {
        dismissLoader();
        handleClose(true);
        errorTost(err.message);
      });
  };

  const handleSaveAndAccept = (ledgerId) => {
    const selectedLedger = [];
    ledgerId.forEach((val) => {
      const index = panBankData?.findIndex(
        (i) =>
          i.booking.ledger.Id === val.ledgerId &&
          i.application.Id === val.applicationId
      );
      if (index !== -1) {
        selectedLedger.push(panBankData[index]);
      }
    });
    presentLoader();
    selectedLedger?.map((val, index) => {
      getCustomerLedgerId(val?.booking.ledger.Code.toString())
        .then((resp) => {
          const payload = {
            state: "Maharashtra",
            city: "Pune",
            country: "India",
            customerId: val?.customer.Id,
            bankDetails: {
              bankAccountNo:
                selectedBankDetails?.customerBankDetails?.accountNo,
              beneficiaryName:
                selectedBankDetails?.customerBankDetails?.accHolderName,
              bankAccountType:
                selectedBankDetails?.customerBankDetails?.accType,
              accountName:
                selectedBankDetails?.customerBankDetails?.accHolderName,
              ifscCode: selectedBankDetails?.customerBankDetails?.ifscCode,
            },
            ledgerId: val?.booking.ledger.Id,
            customerLedgerId: resp?.data[0]?.customerLedgerRes?.outputList
              ?.ledgerId
              ? resp?.data[0]?.customerLedgerRes?.outputList?.ledgerId
              : null,
            code: val?.booking.ledger.Code,
          };
          UpdateLedgerData(payload)
            .then((data) => {
              // to-do: update api
              const payload1 = {
                refundFormId: selectedBankDetails?.id,
                customerId: val?.customer.Id,
                applicationLedgerId: val?.booking.ledger.Id,
                customerLedgerId: resp?.data[0]?.customerLedgerRes?.outputList
                  ?.ledgerId
                  ? resp?.data[0]?.customerLedgerRes?.outputList?.ledgerId
                  : null,
                applicationLedgerRes: data?.data?.applicationLedger
                  ? data?.data?.applicationLedger?.status
                  : false,
                customerLedgerRes: data?.data?.customerLedger
                  ? data?.data?.customerLedger?.status
                  : false,
              };

              if (data?.data?.applicationLedger?.status === true) {
                isAccepted.current = true;
              }

              if (data?.data?.customerLedger?.status === true) {
                isAccepted.current = true;
              }
              inserRefundFormLedger(payload1)
                .then((pay) => {
                  dismissLoader();
                  if (selectedLedger?.length - 1 === index) {
                    if (isAccepted.current === true) {
                      handleUpdateStatus(
                        "accepted",
                        selectedBankDetails,
                        index
                      );
                    } else {
                      errorTost("Couldn't update ledger.");
                    }
                  }
                  selectedLedger?.length - 1 === index && handleClose(true);
                })
                .catch((err) => {
                  dismissLoader();
                  handleClose(true);
                  errorTost(err.message);
                });
            })
            .catch((err) => {
              errorTost(err.message);
              dismissLoader();
            });
        })
        .catch((err) => {
          dismissLoader();
          errorTost(err.message);
        });
    });
  };
  return (
    <Modal
      open={open}
      onClose={() => handleClose(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(193, 201, 210, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.header}>
          <h1>View Bank Details</h1>
          <IconButton
            className={cssClasses.crossButton}
            onClick={() => handleClose(false)}
          >
            {" "}
            <CloseIcon />{" "}
          </IconButton>
        </div>

        <div className={cssClasses.headerDetails}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label>
              <span style={{ fontFamily: "inter-semibold", color: "#98a2b3" }}>
                Ledger Name :
              </span>
              <span className={cssClasses.labelName}>
                {bookAppData?.ledger?.Description
                  ? bookAppData?.ledger?.Description
                  : "-"}
              </span>
            </label>
            {bookAppData?.ledger ? (
              <label style={{ fontFamily: "inter-semibold" }}>
                {
                  <>
                    <span>
                      {bookAppData?.project?.wingName} -{" "}
                      {bookAppData?.project?.UnitCode}{" "}
                    </span>
                    <span>|</span>
                    <span>{bookAppData?.project?.BusinessUnitDescription}</span>
                  </>
                }
              </label>
            ) : (
              ""
            )}
          </div>
        </div>

        <div className={cssClasses.detailsWrapper}>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            <label
              style={{
                fontFamily: "inter-semibold",
                marginBottom: "3px",
                fontSize: "1.8rem",
              }}
            >
              Ledger Details
            </label>
            <label>
              <span style={{ fontFamily: "inter-semibold", color: "#98a2b3" }}>
                Pan Number
              </span>{" "}
              :{" "}
              <span className={cssClasses.labelName}>
                {panNumberDetails?.UDF_16 ? panNumberDetails?.UDF_16 : "-"}
              </span>
            </label>
            <label>
              <span style={{ fontFamily: "inter-semibold", color: "#98a2b3" }}>
                Customer Name
              </span>{" "}
              :{" "}
              <span
                className={
                  selectedBankDetails?.isFlagged
                    ? cssClasses?.panNameChip
                    : cssClasses.labelName
                }
              >
                {panNumberDetails?.description?.includes("undefined")
                  ? "-"
                  : panNumberDetails?.description
                  ? panNumberDetails?.description
                  : "-"}
              </span>
            </label>
            <label>
              <span style={{ fontFamily: "inter-semibold", color: "#98a2b3" }}>
                Email
              </span>{" "}
              :{" "}
              <span className={cssClasses.labelName}>
                {panNumberDetails?.email ? panNumberDetails?.email : "-"}
              </span>
            </label>
            <label>
              <span style={{ fontFamily: "inter-semibold", color: "#98a2b3" }}>
                Mobile No.
              </span>{" "}
              :{" "}
              <span className={cssClasses.labelName}>
                {panNumberDetails?.mobile
                  ? "+91" + panNumberDetails?.mobile
                  : "-"}
              </span>
            </label>
          </div>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            <label
              style={{
                fontFamily: "inter-semibold",
                marginBottom: "3px",
                fontSize: "1.8rem",
              }}
            >
              Bank Details
            </label>
            <label>
              <span style={{ fontFamily: "inter-semibold", color: "#98a2b3" }}>
                Account No.
              </span>{" "}
              :{" "}
              <span className={cssClasses.labelName}>
                {selectedBankDetails?.customerBankDetails?.accountNo}
              </span>
            </label>
            <label>
              <span style={{ fontFamily: "inter-semibold", color: "#98a2b3" }}>
                Account Holder Name
              </span>{" "}
              : {/* <span className={cssClasses.labelName}> */}
              <span
                className={
                  selectedBankDetails?.isFlagged
                    ? cssClasses?.panNameChip
                    : cssClasses.labelName
                }
              >
                {selectedBankDetails?.customerBankDetails?.accHolderName}
              </span>
            </label>
            <label>
              <span style={{ fontFamily: "inter-semibold", color: "#98a2b3" }}>
                Bank Ifsc Code
              </span>{" "}
              :{" "}
              <span className={cssClasses.labelName}>
                {selectedBankDetails?.customerBankDetails?.ifscCode}
              </span>
            </label>
            <label>
              <span style={{ fontFamily: "inter-semibold", color: "#98a2b3" }}>
                Bank Branch
              </span>{" "}
              :{" "}
              <span className={cssClasses.labelName}>
                {selectedBankDetails?.customerBankDetails?.bankName}
              </span>
            </label>
            <label>
              <span style={{ fontFamily: "inter-semibold", color: "#98a2b3" }}>
                Account Type
              </span>{" "}
              :{" "}
              <span className={cssClasses.labelName}>
                {selectedBankDetails?.customerBankDetails?.accType === "SB"
                  ? "Savings"
                  : "Current"}
              </span>
            </label>
          </div>
          <div>
            {selectedBankDetails?.status === "pending" ? (
              <LeadStatusChip
                label={selectedBankDetails.status}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                style={{
                  color: "rgb(181, 71, 8)",
                  backgroundColor: "rgb(255, 250, 235)",
                }}
              ></LeadStatusChip>
            ) : selectedBankDetails?.status === "accepted" ? (
              <LeadStatusChip
                label={selectedBankDetails.status}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                style={{
                  color: "rgb(2, 122, 72)",
                  backgroundColor: "rgb(236, 253, 243)",
                }}
              ></LeadStatusChip>
            ) : (
              <LeadStatusChip
                label={selectedBankDetails.status}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                style={{
                  color: "rgb(192, 16, 72)",
                  backgroundColor: "rgb(255, 241, 243)",
                }}
              ></LeadStatusChip>
            )}
          </div>
        </div>

        {selectedBankDetails?.status === "pending" && (
          <div className={cssClasses.footer}>
            <div>
              <Button
                style={{ color: "#344054", backgroundColor: "#ffffff" }}
                btnName={"Reject"}
                clicked={() => {
                  handleUpdateStatus("rejected", selectedBankDetails);
                }}
              />
            </div>
            <div>
              <Button
                style={{
                  color: "rgb(255, 255, 255)",
                  backgroundColor: "rgb(0, 106, 255)",
                }}
                btnName={"Accept"}
                clicked={() => {
                  setShowAcceptConfirmationModal(true);
                  //handleUpdateStatus("accepted", selectedBankDetails);
                }}
              />
            </div>
          </div>
        )}

        {selectedBankDetails?.status === "accepted" && (
          <div className={cssClasses.footer}>
            <div>
              <Button
                style={{
                  color: "rgb(255, 255, 255)",
                  backgroundColor: "rgb(0, 106, 255)",
                }}
                btnName={"View Ledger Updates"}
                clicked={() => {
                  setShowAcceptConfirmationModal(true);
                  setIsAlreadyAccepted(true);
                  //handleUpdateStatus("accepted", selectedBankDetails);
                }}
              />
            </div>
          </div>
        )}
        {showAcceptConfirmationModal && (
          <ViewAcceptDetailsModal
            open={showAcceptConfirmationModal}
            selectedBankDetails={selectedBankDetails}
            handleClose={() => {
              setShowAcceptConfirmationModal(false);
              setIsAlreadyAccepted(false);
            }}
            bookAppData={bookAppData}
            panBankData={panBankData}
            handleSaveAndAccept={(ledgerNo) => {
              setShowAcceptConfirmationModal(false);
              handleSaveAndAccept(ledgerNo);
            }}
            isAlreadyAccepted={isAlreadyAccepted}
          />
        )}
      </Box>
    </Modal>
  );
};

export default ViewBankDetailsModal;
